import { Button } from "@acdc2/ui/components/button";
import { Form, FormMessage } from "@acdc2/ui/components/access-form";
import { Input } from "@acdc2/ui/components/input";
import { mdiCheck, mdiClose, mdiDelete, mdiPencil } from "@mdi/js";
import { Icon } from "@mdi/react";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Field, Control } from "@radix-ui/react-form";

type Props = {
  defaultValue: string;
  onSave: (author: string) => void;
  onDelete: () => void;
};

export function MetadataAuthorInput({ defaultValue, onDelete, onSave }: Props) {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(!defaultValue);
  const [editInput, setEditInput] = useState(defaultValue);

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!editInput) return;
    onSave(editInput);
    setIsEditing(false);
  };

  const onReset = (event: React.FormEvent) => {
    event.preventDefault();
    setEditInput(defaultValue);
    setIsEditing(false);
  };

  return (
    <Form onSubmit={onSubmit} onReset={onReset}>
      <div className="flex flex-row gap-2">
        <Field name="author" className="flex-1">
          <Control asChild>
            <Input
              defaultValue={defaultValue}
              type="text"
              onChange={(event) => {
                setEditInput(event.target.value);
              }}
              disabled={!isEditing}
              placeholder={t("MetadataAuthorInput.placeholder")}
              required
            />
          </Control>
        </Field>

        <div className="flex flex-row gap-2">
          {isEditing ? (
            <Fragment key="editing-buttons">
              <Button type="submit" size="icon" variant="outline">
                <Icon path={mdiCheck} size="1.25rem" />
              </Button>
              <Button type="reset" size="icon" variant="outline">
                <Icon path={mdiClose} size="1.25rem" />
              </Button>
            </Fragment>
          ) : (
            <Fragment key="view-buttons">
              <Button
                type="button"
                size="icon"
                variant="outline"
                onClick={() => setIsEditing(true)}
              >
                <Icon path={mdiPencil} size="1.25rem" />
              </Button>
              <Button
                type="button"
                size="icon"
                variant="outline"
                onClick={() => onDelete()}
              >
                <Icon path={mdiDelete} size="1.25rem" />
              </Button>
            </Fragment>
          )}
        </div>
      </div>
      <div className="flex flex-col">
        <FormMessage name="author" match="valueMissing" className="mt-1">
          {t("MetadataAuthorInput.errors.authorMissing")}
        </FormMessage>
      </div>
    </Form>
  );
}
